import React from 'react'


const Button = ({
  disabled,
  onClick,
  children,
  title = null,
  type = 'button',
  profile = false,
  ...buttonProps
}) => {

  const handleOnclick = () => {
    if (!onClick) {
      return
    }
    onClick()
  }
  const buttonStyle = profile ? 'button-profile-box' : 'button-box'
  return (
    <span className='button'>
      <button
        disabled={disabled}
        onClick={handleOnclick}
        className={buttonStyle}
        type={type}
        {...buttonProps}
      >
        <span title={title}>
          {children}
        </span>
      </button>
    </span>
  )
}

export default Button
